module.exports = __webpack_public_path__ + "img/solo.686ba15b.webp";